export const SHARP_ICON_NAMES = [
  'ai-generate-text-spark',
  'backpack',
  'book-flip',
  'calendar-mark',
  'chat-two-bubbles-oval',
  'clipboard-text-task',
  'content-browser-edit',
  'cyborg-2',
  'globe-website-setting',
  'heart-support',
  'lightbulb',
  'notepad-text',
  'task-list',
  'toolbox',
  'web-application-learning',
] as const;

export type SharpIconName = (typeof SHARP_ICON_NAMES)[number];
